<div class="sky-club-page">
  @if (content) {
    <div>
      @let overview = content.overview;
      @if (overview) {
        <div class="sky-club-page__header">
          <div class="sky-club-page__text">
            <h2 class="sky-club-page__title">{{ overview.header }}</h2>
            <hr class="sky-club-page__line" />
          </div>
        </div>
      }

      <div class="sky-club-page__background-image"></div>

      <div class="sky-club-page__content">
        <div>
          <section>
            <hr class="sky-club-page__margin" />
          </section>
        </div>

        @let overviewCard = overview.card;

        <div class="sky-club-page__sub-header">
          <div class="sky-club-page__icon">
            <span class="sky-club-page__sub-icon"></span>
          </div>
          <div class="sky-club-page__title-section">
            <h2 class="sky-club-page__sub-title">
              {{ overview.title }}
            </h2>
          </div>
        </div>

        <div class="sky-club-page__details">
          @if (overview.expires) {
            <div class="sky-club-page__expiry-message">
              <img class="sky-club-page__expiry-icon" alt="alert" />
              Your active Membership
              <span class="sky-club-page__expiry-date">
                Expires {{ overview.expiryDate }}
              </span>
            </div>
          }
          @if (content.checkout.error) {
            <div>
              <aura-error-message
                [content]="content.checkout.error"
              ></aura-error-message>
            </div>
          }
          <section class="sky-club-page__wrapper">
            <p
              class="sky-club-page__description"
              [innerHTML]="overview.description"
            ></p>
          </section>
          @let overviewDetails = overview.details;
          <section class="sky-club-page__wrapper">
            <span class="sky-club-page__fewer-details"></span>
            <span
              [innerHTML]="
                details
                  ? overviewDetails.toggle.collapse
                  : overviewDetails.toggle.expand
              "
              (click)="details = !details"
              class="sky-club-page__toggle"
            ></span>

            @if (details) {
              <div>
                <h2 class="sky-club-page__membership-title">
                  {{ overviewDetails.title }}
                </h2>
                <ul class="sky-club-page__items">
                  <li>
                    <h3 class="sky-club-page__list">
                      {{ overviewDetails.memberships[0].title }}
                    </h3>
                    <span
                      [innerHTML]="overviewDetails.memberships[0].subtitle"
                    ></span>
                  </li>

                  <li>
                    <h3 class="sky-club-page__list">
                      {{ overviewDetails.memberships[1].title }}
                    </h3>
                    <span
                      [innerHTML]="overviewDetails.memberships[1].subtitle"
                    ></span>
                  </li>
                </ul>
              </div>
            }
          </section>

          @if (!content.isLoggedIn) {
            <section class="sky-club-page__wrapper">
              <h1
                class="sky-club-page__information"
                [innerHTML]="overview.information"
              ></h1>
            </section>
          }

          <section class="sky-club-page__wrapper">
            <h4 class="sky-club-page__card-title">
              {{ overviewCard.title }}
            </h4>
            <p
              class="sky-club-page__description"
              [innerHTML]="overviewCard.description"
            ></p>
            <p class="sky-club-page__description">
              <a
                [href]="overviewCard.cardAction"
                aria-label="Apply now for Delta SkyMiles Reserve American Express Card"
              >
                {{ overviewCard.actionLabel }}
              </a>
            </p>
            <p
              class="sky-club-page__description"
              [innerHTML]="overviewCard.disclosure"
            ></p>
          </section>

          <section class="sky-club-page__wrapper">
            <span
              class="sky-club-page__description"
              [innerHTML]="overviewCard.support"
            ></span>
          </section>

          <section class="sky-club-page__purchase-section">
            @if (!content.checkout.showCheckout) {
              <idp-purchase-options
                [content]="content.purchase"
                [checkout]="content.checkout"
                [skeletonMetaData]="{
                  loaded: content.purchase.loaded,
                  error: content.purchase.error,
                  disabled: content.purchase.disabled
                }"
                auraSkeletonLoader
                (addToCart)="addToCart.emit($event)"
              ></idp-purchase-options>
            }
            @if (content.checkout.showCheckout) {
              <idp-checkout
                [content]="content.checkout"
                (checkOut)="checkOut.emit()"
                (previousButton)="previousButton.emit()"
                (returnToSkyClub)="returnToSkyClub.emit()"
              ></idp-checkout>
            }
          </section>
        </div>
      </div>
    </div>
  }
</div>
